import React from 'react';
import './Feature.scss';
import { Typography } from '@mui/material';

interface FeatureProps {
  children: React.ReactNode;
}

function Feature({ children }: FeatureProps) {
  return (
    <Typography className="feature-list-item" variant="body2">
      {children}
    </Typography>
  );
}

export default Feature;
